import LoginResult from '@ts-digital/digital-login-component/dist/types/LoginResult'
import { createContext, FC, useEffect, useMemo, useState } from 'react'
import { Auth, AuthContext } from './auth.types'
import jwt from 'jwt-decode'
import { TokenLoginInfo } from 'src/app/types/login.types'

export const authContext = createContext<AuthContext>({} as AuthContext)

export const AuthProvider: FC = ({ children }) => {
  const auth = useProvideAuth()
  return <authContext.Provider value={auth}>{children}</authContext.Provider>
}

const useProvideAuth = (): AuthContext => {
  const [auth, setAuth] = useState<Auth>({ loading: true, isAuthenticated: false })

  // --------------------------------------------------------------
  // TODO: TEMPORARY LOCAL STORAGE MANAGEMENT OF AUTH, WAITING FOR 1FRONT
  // --------------------------------------------------------------
  useEffect(() => {
    const storageAuthStr = localStorage.getItem('hic-auth')
    if (storageAuthStr) {
      const storageAuth = JSON.parse(storageAuthStr)
      if (storageAuth.isAuthenticated) {
        setAuth(storageAuth)
      } else {
        setAuth({ loading: false, isAuthenticated: false })
      }
    } else {
      setAuth({ loading: false, isAuthenticated: false })
    }
  }, [])

  useEffect(() => {
    localStorage.setItem('hic-auth', JSON.stringify(auth))
    if (auth.isAuthenticated && auth.token) localStorage.setItem('hic-token', auth.token)
  }, [auth])
  // --------------------------------------------------------------

  const login = (loginResult: LoginResult) => {
    setAuth({ loading: false, isAuthenticated: true, ...loginResult })
    if (loginResult.token) {
      localStorage.setItem('hic-token', loginResult.token)
    }
  }

  const refresh = (accessToken: string, refreshToken: string) => {
    if (auth.isAuthenticated) {
      setAuth({ ...auth, token: accessToken, refreshToken: refreshToken })
      localStorage.setItem('hic-token', accessToken)
    }
  }

  const logout = () => {
    setAuth({ loading: false, isAuthenticated: false })
    localStorage.removeItem('hic-token')
  }

  const loginInfo = useMemo(() => (auth.isAuthenticated ? jwt<TokenLoginInfo>(auth.idToken) : undefined), [auth])

  return {
    login,
    refresh,
    logout,
    auth,
    loginInfo,
  }
}
